import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";

export interface SidebarNavItem {
  label: string;
  to: string;
}

interface SidebarProps {
  title: string;
  subtitle?: string;
  items: SidebarNavItem[];
  footer?: ReactNode;
}

export function Sidebar({ title, subtitle, items, footer }: SidebarProps) {
  return (
    <aside className="flex h-full w-60 shrink-0 flex-col border-r border-line bg-paper-raised">
      <div className="px-5 py-6">
        <p className="font-display text-lg text-ink">{title}</p>
        {subtitle && <p className="text-xs text-ink-soft">{subtitle}</p>}
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to.split("/").length <= 2}
            className={({ isActive }) =>
              `block rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-brand-50 text-brand-700"
                  : "text-ink-soft hover:bg-paper hover:text-ink"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      {footer && <div className="border-t border-line px-5 py-4">{footer}</div>}
    </aside>
  );
}
